import React from "react";

// Small brand mark — the FarmStory shape mnemonic.
// Renders quietly above headings as a section-opener accent.
export default function Mnemonic({
  size = 56,
  className = "",
  style = {},
  alt = "FarmStory",
}) {
  return (
    <img
      src="/brand/mnemonic.webp"
      alt={alt}
      className={className}
      style={{
        width: size,
        height: "auto",
        display: "block",
        ...style,
      }}
    />
  );
}
